import classNames from 'classnames'

import { faChartPie } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'
import { Trans } from '@lingui/macro'
import Link from 'Root/Component/Link'

import styles from '../index.module.css'

interface Props {
  slug: string
}

const Statistics = ({ slug }: Props) => {
  return (
    <Menu.Item>
      {({ active }) => (
        <Link
          to={{
            pathname: `/collections/${slug}/stats`,
            query: 'fallbackHome=false',
          }}
          as={`/collections/${slug}/stats`}
          className={classNames(
            active ? styles.active : styles.notActive,
            styles.item
          )}
        >
          <FontAwesomeIcon className={styles.icon} icon={faChartPie} />
          <Trans>Statistiche</Trans>
        </Link>
      )}
    </Menu.Item>
  )
}

export default Statistics
